// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m7kJ","type":"styles_type__215nC","choices":"styles_choices__2kiCs"};